import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=3c098fa4&scoped=true"
import script from "./CloseIcon.vue?vue&type=script&lang=js"
export * from "./CloseIcon.vue?vue&type=script&lang=js"
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=3c098fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c098fa4",
  null
  
)

export default component.exports